module.exports = __webpack_public_path__ + "img/avatar03.b21a218b.jpg";